// 某一系列的组件群
export const seriesName = 'list-outer';
